import Vue from 'vue'
import App from '@/App.vue'
import router from '@/router'
import store from '@/store'
import {BootstrapVue, BootstrapVueIcons} from 'bootstrap-vue'
import Confirm from '@/confirm'
import OktaAuth from '@okta/okta-vue'
import jQuery from 'jquery'
import Loading from '@/loading'
import VueAnalytics from 'vue-analytics'
import VueObserveVisibility from 'vue-observe-visibility'
import common from "@/services/common"
import VueClipboard from 'vue-clipboard2'
import VueUniqueId from 'vue-unique-id'

Vue.config.errorHandler = function (err, vm, info) {
  console.error(`Error in ${info}:`, err)
}

Vue.config.productionTip = false
Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
Vue.use(VueObserveVisibility)
Vue.use(Confirm)
Vue.use(Loading)
Vue.use(VueClipboard)
Vue.use(VueUniqueId)

console.log(`Environment: '${process.env.NODE_ENV}'`)
const isQaOrProd = common.isEnv('production') || common.isEnv('qa')

Vue.use(OktaAuth, {
  url: process.env.VUE_APP_OKTA_URL,
  issuer: process.env.VUE_APP_OKTA_ISSUER,
  clientId: process.env.VUE_APP_OKTA_CLIENT_ID,
  redirectUri: process.env.VUE_APP_OKTA_REDIRECT_URI,
  scope: "openid profile email",
  pkce: false,
  tokenManager: {
    // Emit expired event 2 minutes before expiration
    // Tokens accessed with tokenManager.get() will auto-renew within 2 minutes of expiration
    expireEarlySeconds: 120,
  },
})

Vue.use(VueAnalytics, {
  id: process.env.VUE_APP_GOOGLE_ANALYTICS_ID,
  autoTracking: {
    exception: true,
  },
  debug: {
    sendHitTask: isQaOrProd,
  },
  router,
})

// define an event bus for sending/receiving messages
Vue.prototype.$bus = new Vue()

// define a way to easily send alert messages to the event bus
Vue.prototype.$alert = {
  info: msg => Vue.prototype.$bus.$emit('send-alert', {text: msg, variant: "info"}),
  success: msg => Vue.prototype.$bus.$emit('send-alert', {text: msg, variant: "success"}),
  warning: msg => Vue.prototype.$bus.$emit('send-alert', {text: msg, variant: "warning"}),
  error: msg => Vue.prototype.$bus.$emit('send-alert', {text: msg, variant: "danger"}),
}

jQuery.extend(true, jQuery.fn.datetimepicker.defaults, {
  icons: {
    time: "far fa-clock",
    date: "far fa-calendar",
    up: "fas fa-arrow-up",
    down: "fas fa-arrow-down",
    previous: "fas fa-chevron-left",
    next: "fas fa-chevron-right",
    today: "fas fa-calendar-check",
    clear: "far fa-trash-alt",
    close: "far fa-times-circle",
  },
})

Vue.filter('formatSize', common.formatSize)
Vue.filter('formatMIME', common.formatMIME)
Vue.filter('formatDate', common.formatDate)
Vue.filter('formatDateTime', common.formatDateTime)

new Vue({
  el: '#app',
  store: store,
  router: router,
  filters: {
    jsonPretty: function (value) {
      return JSON.stringify(JSON.parse(value), null, 2)
    },
  },
  render: h => h(App),
})
